import { FC, memo } from 'react'

import { pushDataLayer } from 'utils/push-data-layer'

import { AnchorButtonProps } from './anchor-button.model'
import { StyledAnchor, StyledLink } from './styles'


export const AnchorButton: FC<AnchorButtonProps> = memo((props:AnchorButtonProps) => {
    const { 
        type = 'next', 
        size = 'md', 
        color = 'default', 
        children, 
        href, 
        dataLayer, 
        id, 
        className,
        onClick
    } = props
    
    const renderAnchor = {
        anchor: (children, href, size, color, dataLayer, id, className) => (
            <StyledAnchor
                id={id}
                className={className}
                href={href}
                $size={size}
                $color={color}
                onClick={() => {
                    if(onClick) onClick()
                    if(dataLayer) pushDataLayer(dataLayer)
                }}
            >
                {children}
            </StyledAnchor>
        ),
        next: (children, href, size, color, dataLayer, id, className) => (
            <StyledLink
                id={id}
                className={className}
                href={href}
                $size={size}
                $color={color}
                {...(dataLayer && { onClick: () => pushDataLayer(dataLayer) })}
            >
                {children}
            </StyledLink>
        )
    }
    
    return <>{renderAnchor[type](children, href, size, color, dataLayer, id, className)}</>
})

AnchorButton.displayName = 'AnchorButton'